// What a reveal card says, and in whose colour.

const PALETTE = [
  "#ffd166", "#4cc9f0", "#06d6a0", "#ef476f",
  "#b892ff", "#ff9f1c", "#7ae582", "#f15bb5",
];

// Always the same colour for the same person, because it comes from their id
// and not from where they happen to sit in a list.
export function memberColor(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

export interface RevealCount {
  /** Everyone who could have answered, so never counting the person it is about. */
  eligible: number;
  got: number;
  youGotIt: boolean;
  youWereSubject: boolean;
}

// One concrete number, never a vague "nobody saw this coming", and never a name.
// Who missed is the crew's business to bring up, not the app's.
export function revealStat({ eligible, got, youGotIt, youWereSubject }: RevealCount): string {
  if (eligible <= 0) return "Nobody else had played this one yet.";
  const missed = eligible - got;
  if (youWereSubject) {
    if (missed === 0) return `All ${eligible} of them got this about you.`;
    if (got === 0) return `None of the ${eligible} got this about you.`;
    return `${missed} of ${eligible} missed this about you.`;
  }
  if (missed === 0) return `All ${eligible} of you got this.`;
  if (got === 0) return `Nobody got this. All ${eligible} of you missed it.`;
  if (youGotIt && missed > 0) return `You got it. ${missed} of ${eligible} missed this.`;
  return `${missed} of ${eligible} missed this, you included.`;
}
